import { render } from "./AppDrawer.vue?vue&type=template&id=54419540&scoped=true"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"

import "./AppDrawer.vue?vue&type=style&index=0&id=54419540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54419540"]])

export default __exports__